import { FormattedMessage } from "react-intl";
import { admin } from "./admin";

export const assignUsersToRoles = {
  label: <FormattedMessage id="ASSIGN_USER_ROLE" />,
  path: (tenantName) => `/${tenantName}/admin/assignUsersToRoles`,
  navLinks: (navigate, tenantName) => [
    {
      key: 1,
      label: admin.name,
      path: admin.path(tenantName),
      // onClick: () => navigate(`${admin.path(tenantName)}`),
      onClick: () => navigate(admin.path(tenantName)),
    },
    {
      key: 2,
      label: assignUsersToRoles.label,
      path: assignUsersToRoles.path,
    //   onClick: () => navigate(`${assignUsersToRoles.path(tenantName)}`),
    onClick: () => navigate(assignUsersToRoles.path(tenantName)),
    },
  ],
};
